import {h, Component} from 'preact';
import request from "../utils/Request";
import {observer} from "mobx-preact";
import {WINPAGE_DELAY} from "../constants/Common";
import {setCookie} from "../utils/Cookie";
import {SHOP} from "../constants/Common";
import {firstGate} from "./NonAnon";
import PhoneInput from 'react-phone-input-2'


@observer
class Form extends Component {
    constructor(props) {
        super(props);

        this.formStore = props.formStore;
        this.campaignStore = props.campaignStore;
        this.appStore = props.appStore;
        this.winPageStore = props.winPageStore;
        this.handleSubmit = this.handleSubmit.bind(this);
        // this.fbDataRef = generateFbDataRef(this.campaignStore.campaign_id)
        this.state = {isUiOpenedClass: ''};
    }

    componentDidMount() {
        this.campaignStore.setPopUpColors(this.popUp);
        document.addEventListener('click', this.handleClickOutside, true);
        setCookie('_kol_saw_pop_up', true, 999)
        setTimeout(() => {
            this.setState({isUiOpenedClass: 'kol-submit-form--ui-open'});
        }, "10");
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
        this.setState({isUiOpenedClass: ''});
    }

    handleClickOutside = event => {
        if (!this.popUp.contains(event.target)) {
            this.appStore.hidePopUp()
        }
    }

    spin(spinDegrees) {
        document.removeEventListener('click', this.handleClickOutside, true);
        const wheelDynamic = document.querySelector('#wheel-dynamic');
        const kolPopup = document.querySelector('#kol-popup');
        kolPopup.style.setProperty("--wheel-dynamic-rotate-deg", spinDegrees + "deg");
        wheelDynamic.classList.add('kol-rotating');
    }

    get formData() {
        const { email, phoneNumber } = this.formStore;
        const { campaign_id } = this.campaignStore;
        return {
            email: email,
            phone_number: phoneNumber,
            campaign: campaign_id,
        }
    }

    showWinPage = () => {
        setTimeout(() => {
            this.appStore.hidePopUp();
            this.appStore.showWinPage = true;
        }, WINPAGE_DELAY);

    };

    handleEmailChange = event => {
        this.formStore.email = event.target.value;
        this.formStore.emailError = null;
    };

    handlePhoneChange = phone => {
        this.formStore.phoneNumber = phone;
        this.formStore.phoneNumberError = null;
    };

    handleGDPRCheckboxChange = event => {
        this.formStore.GDPRCheckBoxError = false;
        this.formStore.GDPRCheckBoxChecked = !this.formStore.GDPRCheckBoxChecked;
    };


    getSpinDegreesByOptionId(optionId) {
        const {campaignOptions} = this.campaignStore;
        const sectorIndex = campaignOptions.findIndex(item => item.id === optionId);
        return 360 * 3 + ((sectorIndex + 1) * 360 / 8 - 22.5);
    }


    handleSubmit(event) {
        event.preventDefault();
        const {
            GDPRComplianceIsActive,
            addCheckboxToGDPRCompliance,
        } = this.campaignStore;
        if (GDPRComplianceIsActive && addCheckboxToGDPRCompliance && !this.formStore.GDPRCheckBoxChecked){
            this.formStore.GDPRCheckBoxError = true;
            return
        }

        this.formStore.disableSubmit = true;
        const hName = 'X' + 'T' + 'O' + 'KEN'
        const header = firstGate(`${this.formData.email || this.formData.phone_number}${SHOP}`)
        request.post('/games/', {...this.formData, [hName]: header}).then(response => {
            this.winPageStore.getDataFromJson(response.data);
            const optionId = response.data.option_id;
            const spinDegrees = this.getSpinDegreesByOptionId(optionId);
            this.spin(spinDegrees);
        }).catch(
            e => {
                if (e.response.data['email']){
                    this.formStore.emailError = e.response.data['email'][0];
                }
                if (e.response.data['phone_number']){
                    this.formStore.phoneNumberError = e.response.data['phone_number'][0];
                }
                this.formStore.disableSubmit = false;
            }
        );
    }

    // getFBGame = (counter) => {
    //     const {campaign_id} = this.campaignStore;
    //     request.get(`/fb_game/${campaign_id}/${this.fbDataRef}/`).then(response => {
    //         this.winPageStore.getDataFromJson(response.data);
    //         const optionId = response.data.option_id;
    //         const spinDegrees = this.getSpinDegreesByOptionId(optionId);
    //         this.spin(spinDegrees);
    //     }).catch(e => {
    //         console.log(e);
    //         if (counter <= 20){
    //            setTimeout(this.getFBGame, 500, counter++)
    //         }
    //     })
    //
    // };

    fbEventHandler = e => {
        if (e.event === 'opt_in') {
            setTimeout(this.getFBGame, 500, 0)
        }

    };
    // getFormInputs = () => {
    //     const {formEmailPlaceholder} = this.campaignStore;
    //     const {email, disableSubmit} = this.formStore;
    //     if (this.campaignStore.campaignType === CAMPAIGN_TYPE_EMAIL) {
    //         return <div><input className="kol-popup__input" type="email"
    //                       placeholder={formEmailPlaceholder}
    //                       name="email" value={email} onChange={this.handleEmailChange}/>
    //                  <input className="kol-button kol-popup__submit" type="submit"
    //                        onClick={this.handleSubmit}
    //                        disabled={disableSubmit ? 'disabled' : ''}
    //                        value="SPIN"/>
    //         </div>
    //
    //     } else if (this.campaignStore.campaignType === CAMPAIGN_TYPE_FACEBOOK) {
    //         return <MessengerSendToMessenger pageId={this.campaignStore.facebookPageId}
    //                                          appId="2576983595957663"
    //                                          dataRef={this.fbDataRef}
    //                                          fbEventHandler={this.fbEventHandler}
    //         />
    //     }
    //     return <div>
    //         <MessengerSendToMessenger pageId={this.campaignStore.facebookPageId}
    //                                   appId="2576983595957663"
    //                                   dataRef={this.fbDataRef}
    //                                   fbEventHandler={this.fbEventHandler}
    //         />
    //         <input className="kol-popup__input" type="email"
    //                placeholder={formEmailPlaceholder}
    //                name="email" value={email} onChange={this.handleEmailChange}/>
    //                   <input className="kol-button kol-popup__submit" type="submit"
    //                        onClick={this.handleSubmit}
    //                        disabled={disableSubmit ? 'disabled' : ''}
    //                        value="SPIN"/>
    //     </div>
    // };

    getFormInputs = () => {
        const {
            formEmailPlaceholder,
            GDPRComplianceIsActive,
            addCheckboxToGDPRCompliance,
            GDPRComplianceText,
            isPhoneNumberCampaign,
        } = this.campaignStore;
        const {email, phoneNumber, disableSubmit, emailError, phoneNumberError} = this.formStore;
        const formInputClass = emailError ? 'kol-popup__input__error' : 'kol-popup__input';
        const indianShops = ['kuvar-jewels-india.myshopify.com', 'gulabojaipur.myshopify.com'];
        const country = indianShops.includes(SHOP) ? 'in' : 'us';
        return <div className="kol-popup__form">
            {isPhoneNumberCampaign ? <PhoneInput
                    country={country}
                    containerClass="kol-input--phone-number"
                    value={phoneNumber}
                    onChange={this.handlePhoneChange}
                    style="high-res"
                /> :
                <input className={formInputClass} type="email"
                       placeholder={formEmailPlaceholder}
                       name="email" value={email} onChange={this.handleEmailChange}/>}

            {emailError ? <span className="kol-email__error">{emailError}</span> : null}
            {phoneNumberError ? <span className="kol-email__error">{phoneNumberError}</span> : null}

            {GDPRComplianceIsActive ?
                <div class="kol-popup__gdpr">
                    {addCheckboxToGDPRCompliance ?
                        <label class={
                            `kol-checkbox-container  kol-popup__gdpr-checkbox ${this.formStore.GDPRCheckBoxError ? 'kol-checkbox-container--error': ''}`
                        }>
                            <input type='checkbox' onChange={this.handleGDPRCheckboxChange}/>
                            <span class="kol-checkbox-checkmark"></span>
                        </label> : null}
                    <p class="kol-text-line-narrow kol-popup__gdpr-text" dangerouslySetInnerHTML={{__html: GDPRComplianceText}}>
                    </p>
                </div> : null}

            <input className="kol-button kol-popup__submit" type="submit"
                   onClick={this.handleSubmit}
                   disabled={disableSubmit ? 'disabled' : ''}
                   value={this.campaignStore.spinButtonText}/>
        </div>
    };

    render() {
        const {campaignOptions, formHeading} = this.campaignStore;
        return <form id="kol-popup"
                     className={`kol-contrast-calc kol-submit-form kol-submit-form--theme-bold ${this.state.isUiOpenedClass}`}
                     onSubmit={this.handleSubmit} ref={popUp => this.popUp = popUp}>
            <div className="kol-popup__header">
                <h5 className="kol-popup__title">
                    {formHeading}
                </h5>
                {this.getFormInputs()}
                <button className="kol-button kol-popup__close" onClick={this.appStore.hidePopUp}>
                    <svg width="16" height="16">
                        <path
                            d="M15.35 14.65a.48.48 0 0 1 0 .7.48.48 0 0 1-.7 0L8 8.71l-6.65 6.64a.47.47 0 0 1-.35.15.47.47 0 0 1-.35-.15.48.48 0 0 1 0-.7L7.29 8 .65 1.35a.48.48 0 0 1 0-.7.48.48 0 0 1 .7 0L8 7.29 14.65.65a.48.48 0 0 1 .7 0 .48.48 0 0 1 0 .7L8.71 8z"/>
                    </svg>
                </button>
            </div>
            <div className="kol-popup__wheel" style={{maxHeight: '360px'}}>
                <svg className="kol-popup__wheel-svg" width="300" height="300" viewBox="0 0 256 256">
                    <circle cx="128" cy="128" r="128" fill="var(--kol-circle-main-color)"/>
                    <g id="wheel-dynamic" className="wheel__text"
                       style="transform-origin: 50% 50%; transform-box: fill-box; text-anchor: middle;"
                       font-size="12"
                       font-family="helvetica neue"
                       fill="var(--kol-sector-text-color)"
                       font-weight="600"
                       onAnimationEnd={this.showWinPage}>
                        <text data-sector-text="1"
                              transform="rotate(-112.5 70.467 -6.88)">{campaignOptions[0].label}</text>
                        <path data-sector="2" d="M37.49 37.49A127.6 127.6 0 0 0 0 128h128z"
                              fill="var(--kol-sector-text-color)" style={{opacity: '0.09'}}/>
                        <text data-sector-text="2"
                              transform="rotate(-157.5 39.172 41.083)">{campaignOptions[1].label}</text>
                        <text data-sector-text="3"
                              transform="rotate(157.5 12.657 81.634)">{campaignOptions[2].label}</text>
                        <path data-sector="4" d="M37.49 218.51A127.6 127.6 0 0 0 128 256V128z"
                              fill="var(--kol-sector-text-color)" style={{opacity: '0.14'}}/>
                        <text data-sector-text="4"
                              transform="rotate(112.5 -18.587 129.594)">{campaignOptions[3].label}</text>
                        <text data-sector-text="5"
                              transform="rotate(67.5 -73.862 214.104)">{campaignOptions[4].label}</text>
                        <path data-sector="6" d="M218.51 218.51A127.6 127.6 0 0 0 256 128H128z"
                              fill="var(--kol-sector-text-color)" style={{opacity: '0.09'}}/>
                        <text data-sector-text="6"
                              transform="rotate(22.5 -308.96 574.57)">{campaignOptions[5].label}</text>
                        <text data-sector-text="7"
                              transform="matrix(.92 -.38 .38 .92 200.41 103.79)">{campaignOptions[6].label}</text>
                        <path data-sector="8" d="M218.51 37.49A127.6 127.6 0 0 0 128 0v128z"
                              fill="var(--kol-sector-text-color)" style={{opacity: '0.14'}}/>
                        <text data-sector-text="8"
                              transform="rotate(-67.5 125.614 -91.383)">{campaignOptions[7].label}</text>
                    </g>
                    <path
                        d="M128,138a10.00023,10.00023,0,1,1,7.071-2.929A10,10,0,0,1,128,138Zm0-18a7.9995,7.9995,0,1,0,5.657,2.343A8.00318,8.00318,0,0,0,128,120Z"
                        fill="242424" opacity=".2"/>
                    <path
                        d="M128 0C102.684 0 77.9366 7.50707 56.8871 21.5719C35.8376 35.6367 19.4315 55.6276 9.74352 79.0165C0.0555058 102.405 -2.47932 128.142 2.45959 152.972C7.3985 177.801 19.5893 200.609 37.4904 218.51C55.3916 236.411 78.199 248.602 103.029 253.541C127.858 258.479 153.595 255.945 176.984 246.257C200.373 236.569 220.363 220.162 234.428 199.113C248.493 178.063 256 153.316 256 128C256 94.0523 242.514 61.495 218.51 37.4903C194.505 13.4857 161.948 0 128 0ZM128 248C104.266 248 81.0656 240.962 61.3317 227.776C41.5978 214.591 26.2171 195.849 17.1346 173.922C8.05204 151.995 5.67564 127.867 10.3059 104.589C14.9361 81.3114 26.365 59.9295 43.1473 43.1472C59.9296 26.3649 81.3116 14.936 104.589 10.3058C127.867 5.67554 151.995 8.05194 173.922 17.1345C195.849 26.217 214.591 41.5977 227.776 61.3316C240.962 81.0655 248 104.266 248 128C248 159.826 235.357 190.348 212.853 212.853C190.349 235.357 159.826 248 128 248Z"
                        fill="var(--kol-sector-text-color)" opacity="0.1"/>
                    <path d="M120,128a7.9995,7.9995,0,1,1,2.343,5.657A8.00318,8.00318,0,0,1,120,128Z" fill="#242424"/>
                    <path
                        d="M116 0.545898L127.809 21L139.619 0.545532C135.709 0.18335 131.768 0 127.809 0C123.855 0 119.915 0.183228 116 0.545898Z"
                        fill="#242424"/>
                </svg>
            </div>
        </form>
    }
}

export default Form;
